module.exports = __webpack_public_path__ + "img/17e84d7230164bacba46bca6b0ff7f06.b704cb3c.png";